import React, { useCallback } from 'react'
import { SafeAreaView, StyleSheet } from 'react-native'
import { useRecoilState } from 'recoil'
import { ScrollView } from 'react-native-gesture-handler'
import { useFocusEffect } from '@react-navigation/native'
import { GetServiceOrderDetail } from '@/domain/usecases'
import { DateAdapter } from '@/data/protocols'
import { Loading, Box } from '@/presentation/components'
import { useErrorHandler } from '@/presentation/hooks'
import { serviceOrderDetailState, PageHeader, ClientInfo, OsInfo, OsProducts, OsServices, OsTotalizer, OsTreatments, OsRemovals, OsWarehouse, OsSignatures, OsProblems } from '@/presentation/pages/ServiceOrderDetail/components'

type ServiceOrderDetailProps = {
  getServiceOrderDetail: GetServiceOrderDetail
  dateAdapter: DateAdapter
}

export const ServiceOrderDetail: React.FC<ServiceOrderDetailProps> = ({
  getServiceOrderDetail,
  dateAdapter
}) => {
  const handleError = useErrorHandler()
  const [serviceOrderDetail, setServiceOrderDetail] = useRecoilState(serviceOrderDetailState)

  useFocusEffect(
    useCallback(() => {
      setServiceOrderDetail(currentState => ({ ...currentState, isLoading: true }))

      const paramsGetOrders = {
        planilha: 289345
      }

      getServiceOrderDetail
        .getDetail(paramsGetOrders)
        .then(serviceOrders => {
          setServiceOrderDetail(currentState => ({ ...currentState, ...serviceOrders }))
        })
        .catch(handleError)
        .finally(() => setServiceOrderDetail(currentState => ({ ...currentState, isLoading: false })))
    }, [])
  )

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      paddingBottom: 60
    },
    content: {
      marginVertical: 0,
      marginHorizontal: 'auto',
      flex: 1,
      padding: 16,
      width: '100%'
    },
    scroll: {
      flex: 1,
      paddingTop: 12
    }
  })

  return (
    <SafeAreaView style={styles.container}>
      <Box style={styles.content}>
        {serviceOrderDetail.isLoading
          ? <Loading text='Buscando OS' />
          : <ScrollView style={styles.scroll}>
            <PageHeader />
            <ClientInfo />
            <OsInfo dateAdapter={dateAdapter}/>
            <OsProducts />
            <OsServices />
            <OsTotalizer />
            <OsTreatments dateAdapter={dateAdapter}/>
            <OsRemovals />
            <OsWarehouse dateAdapter={dateAdapter}/>
            <OsProblems dateAdapter={dateAdapter}/>
            <OsSignatures />
          </ScrollView>
        }
      </Box>
    </SafeAreaView>
  )
}
